export default {
    url: '/view/:id',
    template: '<user-competence-competence-view competence="vm.competence"/>',
    resolve: {
        competence (CompetenceResource, $stateParams) {
            return CompetenceResource.get({ id: $stateParams.id }).$promise;
        }
    },
    controller (competence) {
        this.competence = competence;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/competence/view/index.js